import { IModalBaseComponent } from '../base/interfaces/IModalBaseComponent';
import { ModalBaseComponent } from '../base/ModalBaseComponent';
import templates from './templates/specialCharactersModal.html';

export class SpecialCharactersModal extends ModalBaseComponent implements IModalBaseComponent {
   private readonly CHARACTERS: Record<string, { char: string, title: string }[]> = {
      'currency': [
         { char: '$', title: 'Dollar sign' },
         { char: '¢', title: 'Cent sign' },
         { char: '€', title: 'Euro sign' },
         { char: '£', title: 'Pound sign' },
         { char: '¥', title: 'Yen sign' },
         { char: '¤', title: 'Currency sign' },
         { char: '₹', title: 'Rupee sign' },
      ],
      'text': [
         { char: '©', title: 'Copyright sign' },
         { char: '®', title: 'Registered sign' },
         { char: '™', title: 'Trade mark sign' },
         { char: '‰', title: 'Per mille sign' },
         { char: 'µ', title: 'Micro sign' },
         { char: '·', title: 'Middle dot' },
         { char: '•', title: 'Bullet sign' },
         { char: '…', title: 'Three dot leader' },
         { char: '′', title: 'Minutes / feet' },
         { char: '″', title: 'Seconds / inches' },
         { char: '§', title: 'Section sign' },
         { char: '¶', title: 'Paragraph sign' },
         { char: 'ß', title: 'Sharp s / ess zed' },
      ],
      'mathematical': [
         { char: 'ƒ', title: 'Function / florin' },
         { char: '∫', title: 'Integral' },
         { char: '∑', title: 'Summation' },
         { char: '∞', title: 'Infinity' },
         { char: '√', title: 'Square root' },
         { char: '∼', title: 'Similar to' },
         { char: '≅', title: 'Approximately equal to' },
         { char: '≈', title: 'Almost equal to' },
         { char: '≠', title: 'Not equal to' },
         { char: '≡', title: 'Indentical to' },
         { char: '∈', title: 'Element of' },
         { char: '∉', title: 'Not element of' },
         { char: '∋', title: 'Contains member' },
         { char: '∏', title: 'n ary product' },
         { char: '∧', title: 'Logical and' },
         { char: '∨', title: 'Logical or' },
         { char: '∩', title: 'Intersection' },
         { char: '∪', title: 'Union' },
         { char: '∂', title: 'Partial differential' },
         { char: '∀', title: 'For all' },
         { char: '∃', title: 'There exist' },
         { char: '∅', title: 'Diameter' },
         { char: '∇', title: 'Backward difference' },
         { char: '∗', title: 'Asterisk operator' },
         { char: '∝', title: 'Proportional to' },
         { char: '∠', title: 'Angle' },
      ],
      'latin': [
         { char: 'À', title: 'A grave' },
         { char: 'Á', title: 'A acute' },
         { char: 'Â', title: 'A circumflex' },
         { char: 'Ã', title: 'A tilde' },
         { char: 'Ä', title: 'A diaeresis' },
         { char: 'Å', title: 'A ring above' },
         { char: 'Ā', title: 'A macron' },
         { char: 'Æ', title: 'ligature AE' },
         { char: 'Ç', title: 'C cedilla' },
         { char: 'È', title: 'E grave' },
         { char: 'É', title: 'E acute' },
         { char: 'Ê', title: 'E circumflex' },
         { char: 'Ë', title: 'E diaeresis' },
         { char: 'Ē', title: 'E macron' },
         { char: 'Ì', title: 'I grave' },
         { char: 'Í', title: 'I acute' },
         { char: 'Î', title: 'I circumflex' },
         { char: 'Ï', title: 'I diaeresis' },
         { char: 'Ī', title: 'I macron' },
         { char: 'Ð', title: 'ETH' },
         { char: 'Ñ', title: 'N tilde' },
         { char: 'Ò', title: 'O grave' },
         { char: 'Ó', title: 'O acute' },
         { char: 'Ô', title: 'O circumflex' },
         { char: 'Õ', title: 'O tilde' },
         { char: 'Ö', title: 'O diaeresis' },
         { char: 'Ø', title: 'O slash' },
         { char: 'Ō', title: 'O macron' },
         { char: 'Œ', title: 'ligature OE' },
         { char: 'Š', title: 'S caron' },
         { char: 'Ù', title: 'U grave' },
         { char: 'Ú', title: 'U acute' },
         { char: 'Û', title: 'U circumflex' },
         { char: 'Ü', title: 'U diaeresis' },
         { char: 'Ū', title: 'U macron' },
         { char: 'Ý', title: 'Y acute' },
         { char: 'Ÿ', title: 'Y diaeresis' },
         { char: 'Ȳ', title: 'Y macron' },
         { char: 'Þ', title: 'THORN' },
         { char: 'à', title: 'a grave' },
         { char: 'á', title: 'a acute' },
         { char: 'â', title: 'a circumflex' },
         { char: 'ã', title: 'a tilde' },
         { char: 'ä', title: 'a diaeresis' },
         { char: 'å', title: 'a ring above' },
         { char: 'ā', title: 'a macron' },
         { char: 'æ', title: 'ligature ae' },
         { char: 'ç', title: 'c cedilla' },
         { char: 'Α', title: 'Alpha' },
         { char: 'Β', title: 'Beta' },
         { char: 'Γ', title: 'Gamma' },
         { char: 'Δ', title: 'Delta' },
         { char: 'Ε', title: 'Epsilon' },
         { char: 'Ζ', title: 'Zeta' },
         { char: 'Η', title: 'Eta' },
         { char: 'Θ', title: 'Theta' },
         { char: 'Ι', title: 'Iota' },
         { char: 'Κ', title: 'Kappa' },
         { char: 'Λ', title: 'Lambda' },
         { char: 'Μ', title: 'Mu' },
         { char: 'Ν', title: 'Nu' },
         { char: 'Ξ', title: 'Xi' },
         { char: 'Ο', title: 'Omicron' },
         { char: 'Π', title: 'Pi' },
         { char: 'Ρ', title: 'Rho' },
         { char: 'Σ', title: 'Sigma' },
         { char: 'Τ', title: 'Tau' },
         { char: 'Υ', title: 'Upsilon' },
         { char: 'Φ', title: 'Phi' },
         { char: 'Χ', title: 'Chi' },
         { char: 'Ψ', title: 'Psi' },
         { char: 'Ω', title: 'Omega' },
         { char: 'α', title: 'alpha' },
         { char: 'β', title: 'beta' },
         { char: 'γ', title: 'gamma' },
         { char: 'δ', title: 'delta' },
         { char: 'ε', title: 'epsilon' },
         { char: 'ζ', title: 'zeta' },
         { char: 'η', title: 'eta' },
         { char: 'θ', title: 'theta' },
         { char: 'ι', title: 'iota' },
         { char: 'κ', title: 'kappa' },
         { char: 'λ', title: 'lambda' },
         { char: 'μ', title: 'mu' },
         { char: 'ν', title: 'nu' },
         { char: 'ξ', title: 'xi' },
         { char: 'ο', title: 'omicron' },
         { char: 'π', title: 'pi' },
         { char: 'ρ', title: 'rho' },
         { char: 'ς', title: 'final sigma' },
         { char: 'σ', title: 'sigma' },
         { char: 'τ', title: 'tau' },
         { char: 'υ', title: 'upsilon' },
         { char: 'φ', title: 'phi' },
         { char: 'χ', title: 'chi' },
         { char: 'ψ', title: 'psi' },
         { char: 'ω', title: 'omega' },
      ],
      'quotations': [
         { char: '‹', title: 'single left pointing angle quotation mark' },
         { char: '›', title: 'single right pointing angle quotation mark' },
         { char: '«', title: 'left pointing guillemet' },
         { char: '»', title: 'right pointing guillemet' },
         { char: '‚', title: 'single low 9 quotation mark' },
         { char: '„', title: 'double low 9 quotation mark' },
         { char: '<', title: 'less than sign' },
         { char: '>', title: 'greater than sign' },
         { char: '≤', title: 'less than or equal to' },
         { char: '≥', title: 'greater than or equal to' },
         { char: '–', title: 'en dash' },
         { char: '—', title: 'em dash' },
         { char: '¯', title: 'macron' },
         { char: '‾', title: 'overline' },
         { char: '¤', title: 'currency sign' },
         { char: '¦', title: 'broken bar' },
         { char: '¨', title: 'diaeresis' },
         { char: '¡', title: 'inverted exclamation mark' },
         { char: '¿', title: 'turned question mark' },
         { char: 'ˆ', title: 'circumflex accent' },
         { char: '˜', title: 'small tilde' },
         { char: '°', title: 'degree sign' },
         { char: '−', title: 'minus sign' },
         { char: '±', title: 'plus minus sign' },
         { char: '÷', title: 'division sign' },
         { char: '⁄', title: 'fraction slash' },
         { char: '×', title: 'multiplication sign' },
         { char: '¹', title: 'superscript one' },
         { char: '²', title: 'superscript two' },
         { char: '³', title: 'superscript three' },
         { char: '¼', title: 'fraction one quarter' },
         { char: '½', title: 'fraction one half' },
         { char: '¾', title: 'fraction three quarters' },
      ],
      'symbols': [
         { char: 'ℵ', title: 'alef symbol' },
         { char: 'ϖ', title: 'Pi symbol' },
         { char: 'ℜ', title: 'Real part symbol' },
         { char: 'ϒ', title: 'Upsilon symbol' },
         { char: '℘', title: 'Weierstrass' },
         { char: 'ℑ', title: 'Imaginary part' },
      ],
      'arrows': [
         { char: '←', title: 'leftwards arrow' },
         { char: '↑', title: 'upwards arrow' },
         { char: '→', title: 'rightwards arrow' },
         { char: '↓', title: 'downwards arrow' },
         { char: '↔', title: 'left right arrow' },
         { char: '↵', title: 'carriage return' },
         { char: '⇐', title: 'leftwards double arrow' },
         { char: '⇑', title: 'upwards double arrow' },
         { char: '⇒', title: 'rightwards double arrow' },
         { char: '⇓', title: 'downwards double arrow' },
         { char: '⇔', title: 'left right double arrow' },
         { char: '∴', title: 'therefore' },
         { char: '⊂', title: 'subset of' },
         { char: '⊃', title: 'superset of' },
         { char: '⊄', title: 'not a subset of' },
         { char: '⊆', title: 'subset of or equal to' },
         { char: '⊇', title: 'superset of or equal to' },
         { char: '⊕', title: 'circled plus' },
         { char: '⊗', title: 'circled times' },
         { char: '⊥', title: 'perpendicular' },
         { char: '⋅', title: 'dot operator' },
         { char: '⌈', title: 'left ceiling' },
         { char: '⌉', title: 'right ceiling' },
         { char: '⌊', title: 'left floor' },
         { char: '⌋', title: 'right floor' },
         { char: '〈', title: 'left pointing angle bracket' },
         { char: '〉', title: 'right pointing angle bracket' },
         { char: '◊', title: 'lozenge' },
         { char: '♠', title: 'black spade suit' },
         { char: '♣', title: 'black club suit' },
         { char: '♥', title: 'black heart suit' },
         { char: '♦', title: 'black diamond suit' },
      ],
   };

   protected render(): HTMLElement {
      return this.createElementFromTemplate(templates);
   }

   protected initialize(): void {
      this.bindShowModal((event) => {
         Object.entries(this.CHARACTERS).forEach(([key, values]) => {
            const container = (event.target as HTMLElement)?.querySelector(`#v-pills-${key} .special-chars-grid`);
            if (container) {
               container.innerHTML = values.map(({ char, title }) => `
                <button type="button" 
                  class="btn btn-outline-primary btn-icon-only" 
                  data-action="click->${this.controllerIdentifier}#insertSpecialCharacter" 
                  data-${this.controllerIdentifier}-character-param="${char}"
                  data-bs-toggle="tooltip" 
                  data-bs-placement="bottom" 
                  data-bs-title="${title}">${char}
                </button>
              `).join('');
            }
         });
      });
   }
}